var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificaciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 8.9C20.19 3.89 15.72 0 10.38 0C5.04 0 0.570001 3.89 0.0600014 8.9C0.0200014 9.02 0 9.15 0 9.28V20.75C0 21.44 0.56 22 1.25 22H6.2C6.56 23.99 8.29 25.5 10.37 25.5C12.45 25.5 14.19 23.99 14.54 22H19.49C20.18 22 20.74 21.44 20.74 20.75V9.28C20.74 9.15 20.72 9.02 20.68 8.9H20.7ZM10.38 23C9.68 23 9.09 22.59 8.81 22H11.96C11.68 22.59 11.08 23 10.39 23H10.38ZM18.26 19.5H2.51V9.56C2.52 9.5 2.53 9.44 2.54 9.37C2.81 5.52 6.26 2.5 10.39 2.5C14.52 2.5 17.97 5.52 18.24 9.37C18.24 9.43 18.25 9.49 18.27 9.56V19.51L18.26 19.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaciones);
export default __webpack_public_path__ + "static/media/notificaciones.8a5386ebce77f513e1afc302e0d2b4ea.svg";
export { ForwardRef as ReactComponent };